import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { SelectableList, SelectableListItem, } from '@/components/ui/List/SelectableList';
import { hotlineClientNegotiateListStyle } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientNegotiateList/style';
/**
 * 匿名コンサルホットライン クライアント チャット一覧（スケルトン）
 */
export const HotlineClientNegotiateListSkeleton = (props) => {
    const { children, className = '', dummies } = props;
    const style = hotlineClientNegotiateListStyle();
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx("div", Object.assign({ className: style.listWrap() }, { children: _jsx(SelectableList, Object.assign({ className: style.list() }, { children: dummies.map(({ index }) => (_jsx(SelectableListItem, { children: _jsx(Skeleton, { className: 'w-full max-w-[300px] h-[20px]' }) }, index))) })) })), _jsx("div", Object.assign({ className: style.content() }, { children: _jsx(SelectableList, { children: children }) }))] })));
};
